import type { Middleware } from "@reduxjs/toolkit";
import { api } from "_shared/_stores/api";
import { notifyPrincipalChangeListeners, principalChanged } from "users/__session/principal-change";

/**
 * RTK Query keeps subscription and request state inside its middleware as well as Redux. Reset it
 * through the public action before the root reducer clears principal-owned state so both halves of
 * the cache cross the identity boundary together and the middleware can register itself again.
 */
export const principalChangeReduxMiddleware: Middleware = ({ dispatch }) => (next) => (action) => {
  if (principalChanged.match(action)) {
    dispatch(api.util.resetApiState());
    notifyPrincipalChangeListeners();
  }
  return next(action);
};
